module.exports = {"id":"221660","name":"Victor Lindelöf","rating":"78","photo":"./data/images/photos/2/221660.png","club":{"name":"Manchester Utd","logo":"./data/images/clubs/ManchesterUtd.png"},"positions":["DC"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/VictorLindelof0.json
// module id = 4254
// module chunks = 0